<template>
  <div class="section--column--center" @keyup.enter="toValidate">
    <div class="TwoFactorWizardstep-size-security data--center">
      <p>{{ $t('TwoFactorAuth.Validate') }}</p>
      <input required type="text" pattern="\d*" minlength="6" maxlength="6" v-model="validationCode" @keypress="handleKeyPress"
             :disabled="!isPossibleValidate" ref="validationCodeRef"/>
      <!--      <InputOtp v-model="validationCode" :length=6 :disabled="!isPossibleValidate" integerOnly ref="validationCodeRef"/>-->
      <p v-if="isInvalidCodeL1"
         class="validation__error">{{ $t('TwoFactorAuth.ValidCodeNoValid1') }}</p>
      <p v-if="isInvalidCodeL2"
         class="validation__error">{{ $t('TwoFactorAuth.ValidCodeNoValid2') }}</p>
      <p v-if="isInvalidCodeL2"
         class="validation__error">{{ $t('TwoFactorAuth.ValidCodeNoValid3') }}
        <strong>{{ errorDateCountdown }}</strong></p>
      <p v-if="isInvalidCodeL2">{{ $t('TwoFactorAuth.isInvalidCodeL2Question') }}
        {{ $t('TwoFactorAuth.isInvalidCodeL2ContactSupport') }}:
        <strong>sat.solar.energy@ingeteam.com</strong></p>
    </div>
    <div class="flex__separate05">
      <button v-if="isPossibleValidate && isSecurityUrl" @click="toBack"
              class="btn btn-primary p-x-2 border__rounded btn-2fa">{{ $t('wizard.previous') }}
      </button>
      <button v-if="isPossibleValidate" @click="toValidate"
              :disabled="!isValidationCodeValid"
              class="btn btn-primary p-x-2 border__rounded btn-2fa">{{ $t('wizard.validate') }}
      </button>
    </div>
  </div>


</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref} from "vue";
import TwoFactorAuthenticationAPPService from "@/services/TwoFactorAuth/TwoFactorAuthenticationAPP.service";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {RouterPaths} from "@/types/RouterData";
import ResponseData from "@/types/ResponseData";
import {
  AuthenticatorValidateResponse, AuthenticatorValidateResponseErrorCode,
  AuthenticatorValidationStatus
} from "@/types/autenticationresult";
import {finalize, map, takeUntil, timer} from "rxjs";
import APIDataServices from "@/services/APIDataServices";

export default defineComponent({
  name: 'validate2fa',
  components: {},
  setup() {

    const store = useStore();
    const route = useRoute();

    const validationCodeRef = ref();

    const validationCode = ref();
    const isInvalidCodeL1 = ref();
    const isInvalidCodeL2 = ref();
    const errorDateCountdown = ref();

    const isValidationCodeValid = computed(() => {
      return validationCode.value?.length === 6;
    });

    const isPossibleValidate = computed(() => {
      return !isInvalidCodeL2.value;
    });

    const currentRoute = computed(() => {
      return route.name;
    });

    const isSecurityUrl = computed(() => {
      return currentRoute.value === RouterPaths.UserSecurity;
    });


    const getSecondsDiff = (date2: Date, date1: Date) => {
      const start = date1.getTime();
      const end = date2.getTime();

      const diff = end - start;
      return Math.floor(diff / 1000);
    }

    const getTimer = (minsDiff: number) => {
      // console.log('getTimer. minsDiff: ' + minsDiff);
      // minsDiff = 0.15;
      let distance = (minsDiff * 1000) - 1000;
      // console.log('getTimer. distance: ' + distance);

      return timer(0, 1000).pipe(
          takeUntil(timer(distance)),
          map(() => {
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            distance -= 1000;
            const msg = `${days ? days + 'd' : ''} ${hours ? hours + 'h' : ''} ${minutes ? minutes + 'm' : ''} ${seconds ? seconds + 's' : ''}`;
            // console.log('getTimer. msg: ' + msg);
            return msg;
          }),
          finalize(() => {
            isInvalidCodeL2.value = false;
            TwoFactorAuthenticationAPPService.resetTwoFactorUserBlockedDate(store);
          })
      )
          .subscribe((value: string) => {
            errorDateCountdown.value = value;
          });
    }
    const setErrorMessageUserBlocked = (BlockedDateStr: string) => {
      // console.log('BlockedDateStr: ' + JSON.stringify(BlockedDateStr));
      const blockedDate = new Date(BlockedDateStr);
      const secondsdiff = getSecondsDiff(blockedDate, new Date());
      getTimer(secondsdiff);
      isInvalidCodeL1.value = false;
      isInvalidCodeL2.value = true;
    }
    const toValidate = () => {
      // const twoFactorToken = BrowsersettingsService.getSessionStorageTwoFactorTokenVariable();
      // console.log('twoFactorToken para validar: ' + JSON.stringify(twoFactorToken));
      // console.log('this.validationCode para validar: ' + JSON.stringify(this.validationCode));
      const tokenUserBlocked = store.getters.getTwoFactorUserBlockedDate;
      // console.log('tokenUserBlocked: ' + JSON.stringify(tokenUserBlocked));
      if (!tokenUserBlocked) {
        // console.log('no esta bloqueado se puede validar')
        APIDataServices.setAuthenticatorValidate(store.getters.getTwoFactorAuthToken, validationCode.value)
            .then((result: ResponseData) => {
                  // console.log('setAuthenticatorValidate. result: ' + JSON.stringify(result));
                  const validateresponse = result.data as AuthenticatorValidateResponse;
                  if (validateresponse && validateresponse.token) {
                    const token = validateresponse.token;
                    // console.log('token: ' + JSON.stringify(token));
                    // console.log('hay token y hay que ir a pantalla dashboard o cerrar wizard validacion');
                    store.commit("setISMToken", token);
                    // BrowsersettingsService.removeSessionStoragePropertyValue(sessionStorageTwoFactorTokenVariable);
                    TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcess(AuthenticatorValidationStatus.Validated, store);
                  }
                },
                (error: any) => {
                  if (error && error.response) {
                    const errordata = error.response.data as AuthenticatorValidateResponse;
                    if (errordata.errorCode && errordata.errorCode === AuthenticatorValidateResponseErrorCode.twoFactorAuthenticationInvalidCode) {
                      isInvalidCodeL1.value = true;
                    } else if (errordata.errorCode && errordata.errorCode
                        === AuthenticatorValidateResponseErrorCode.twoFactorAuthenticationAttemptsLimitReached) {
                      const blockdate = errordata.blockEndsAt ? errordata.blockEndsAt : '';
                      setErrorMessageUserBlocked(blockdate);
                    }
                    validationCode.value = '';
                  }
                });
      } else {
        setErrorMessageUserBlocked(tokenUserBlocked);
      }
    }

    onMounted(() => {
      const blockedDate = store.getters.getTwoFactorUserBlockedDate;
      if (blockedDate) {
        setErrorMessageUserBlocked(blockedDate);
      }
      if (validationCodeRef.value) {
        validationCodeRef.value.focus();
      }
    });

    const handleKeyPress = (evt: any) => {
      const ASCIICode = (evt.which) ? evt.which : evt.keyCode
      if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
        evt.preventDefault();
        return false;
      }
      return true;
    };

    const toBack = () => {
      TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcessWizard(false, store);
    }

    return {
      toValidate,
      toBack,
      handleKeyPress,
      isValidationCodeValid,
      isPossibleValidate,
      isInvalidCodeL1,
      isInvalidCodeL2,
      isSecurityUrl,
      errorDateCountdown,
      validationCode,
      validationCodeRef
    }
  }
});

</script>


<style scoped>
.code--field {
  background-color: lightgrey;
  border: 2px solid #000;
  border-radius: 15px;
  padding: 5px;
  display: inline-block;
}
</style>
